<template>
    <router-view/>
    <modal-confirm v-show="$store.state.modalData.showModal" @close="$store.state.modalData.showModal = false"
                   :msg="$store.state.modalData.msg" :theme="$store.state.modalData.theme"
                   :inverted="$store.state.modalData.inverted"
                   :action="$store.state.modalData.action" :async="$store.state.modalData.async"></modal-confirm>
    <modal-success-message v-show="$store.state.confirmData.showModal"
                           @close="$store.state.confirmData.showModal = false"
                           :msg="$store.state.confirmData.msg" :theme="$store.state.confirmData.theme">
    </modal-success-message>
</template>
<script>
    import ModalSuccessMessage from "./base/components/ModalSuccessMessage";
    import ModalConfirm from "./base/components/ModalConfirm";

    export default {
        components: {ModalConfirm, ModalSuccessMessage},
        watch: {
            $route: {
                immediate: true,
                handler(to) {
                    document.title = to.meta.title || 'Processo de Seleção';
                }
            },
        }
    }
</script>